import React from 'react';
import { RichText, RichTextProps, Wrap } from '@leafwell/components';

import TextHighlight from './text-highlight';

export type WysiwygContentProps = Omit<RichTextProps, 'content'> & {
  content?: string;
  containerSize?: 'small' | 'default' | 'large' | 'full';
  sectionId?: string;
  acfFcLayout?: string;
};

const WysiwygContent: React.FC<WysiwygContentProps> = ({
  content,
  containerSize,
  className,
  sectionId,
  ...rest
}) => {
  const Wrapper =
    containerSize && containerSize !== 'full' ? Wrap : React.Fragment;
  const { acfFcLayout, ...params } = rest;

  return (
    <Wrapper
      {...(containerSize
        ? {
            // @ts-ignore
            size: containerSize,
            id: sectionId,
            className: 'lw-rich-text-block',
            ...params,
          }
        : {})}
    >
      <RichText
        content={<TextHighlight text={content} />}
        className={[className, 'prose lg:prose-lg xl:prose-xl'].join(' ')}
        {...(containerSize ? {} : rest)}
      />
    </Wrapper>
  );
};

export default WysiwygContent;
